import { ReactElement } from "react"

import AppChip from "../../dataDisplay/chips/appChip"

interface MfaChipProps {
    isFalseMfa: boolean
}

/** Chip to display MFA status in and user management portal */
const MfaChip = ({ isFalseMfa }: MfaChipProps): ReactElement => {
    if (!isFalseMfa) {
        return <AppChip label="MFA Enabled" variant="filled" color="success" />
    }
    return <AppChip label="MFA Disabled" variant="filled" color="success" />
}

export default MfaChip
